import { ApiResponse } from "@/api/types";

export type OmittedEventDetail = Omit<
  ApiResponse.EventDetail,
  "id" | "clip_id" | "graduate_year" | "name"
>;

export type Key = keyof OmittedEventDetail;

export const Labels = {
  overview: "簡単な概要・ポイント",
  screening_process: "選考フロー",
  schedule: "開催日程",
  period: "期間（日間）",
  location: "開催場所",
  number_of_participants: "受入人数",
  deadline: "締め切り（募集期間）",
  reward: "報酬",
  treatment: "待遇",
  target: "対象学生",
  reference_url: "参照URL"
};
